import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { PhoneIcon, ShieldCheckIcon, UserIcon, CalendarIcon, ArrowLeftIcon } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { useAuth } from '../../lib/AuthContext';
type Step = 'phone' | 'otp' | 'profile';
export function LoginPage() {
  const navigate = useNavigate();
  const {
    customerLogin,
    updateCustomer,
    currentCustomer
  } = useAuth();
  const [step, setStep] = useState<Step>('phone');
  const [phone, setPhone] = useState('');
  const [otp, setOtp] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const [otpError, setOtpError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [name, setName] = useState('');
  const [dob, setDob] = useState('');
  const [gender, setGender] = useState('');
  const handlePhoneSubmit = () => {
    const cleaned = phone.replace(/\D/g, '');
    if (cleaned.length < 10) {
      setPhoneError('Số điện thoại phải có ít nhất 10 số');
      return;
    }
    setPhoneError('');
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      setStep('otp');
    }, 800);
  };
  const handleOtpSubmit = () => {
    if (otp.length !== 6) {
      setOtpError('Mã OTP phải có 6 số');
      return;
    }
    setOtpError('');
    setIsLoading(true);
    setTimeout(() => {
      const cleaned = phone.replace(/\D/g, '');
      customerLogin(cleaned.startsWith('0') ? cleaned : `0${cleaned}`);
      setIsLoading(false);
      setStep('profile');
    }, 800);
  };
  const handleProfileSubmit = () => {
    updateCustomer({
      name: name || currentCustomer?.name || '',
      dateOfBirth: dob || undefined,
      gender: gender as 'male' | 'female' | 'other' | undefined
    });
    navigate('/vi');
  };
  const handleSkipProfile = () => {
    navigate('/vi');
  };
  return <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-4 py-12" data-id="element-1384">
      <div className="w-full max-w-md" data-id="element-1385">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-center mb-8" data-id="element-1386">
          <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#C8A84E] to-[#B8963E] flex items-center justify-center mx-auto mb-4" data-id="element-1387">
            <span className="text-[#0D0D0D] font-bold text-lg" data-id="element-1388">MHP</span>
          </div>
          <h1 className="text-2xl font-bold text-white" data-id="element-1389">
            {step === 'phone' && 'Đăng Nhập / Đăng Ký'}
            {step === 'otp' && 'Xác Nhận OTP'}
            {step === 'profile' && 'Thông Tin Cá Nhân'}
          </h1>
          <p className="text-sm text-[#B0B0B0] mt-1" data-id="element-1390">
            {step === 'phone' && 'Nhập số điện thoại để bắt đầu'}
            {step === 'otp' && `Mã xác nhận đã gửi đến ${phone}`}
            {step === 'profile' && 'Bổ sung thông tin (không bắt buộc)'}
          </p>
        </motion.div>

        <div className="bg-[#1A1A1A] border border-[#2A2A2A] rounded-xl p-6" data-id="element-1391">
          <AnimatePresence mode="wait" data-id="element-1392">
            {step === 'phone' && <motion.div key="phone" initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -20
          }} transition={{
            duration: 0.2
          }} data-id="element-1393">
                <Input label="Số điện thoại" type="tel" placeholder="0901 234 567" value={phone} onChange={e => {
              setPhone(e.target.value);
              setPhoneError('');
            }} error={phoneError} leftIcon={<PhoneIcon className="w-4 h-4" data-id="element-1395" />} onKeyDown={e => {
              if (e.key === 'Enter') handlePhoneSubmit();
            }} autoFocus data-id="element-1394" />
                <Button fullWidth className="mt-4" onClick={handlePhoneSubmit} isLoading={isLoading} data-id="element-1396">
                  Tiếp Tục
                </Button>
                <p className="text-xs text-[#666666] text-center mt-4" data-id="element-1397">
                  Bằng việc tiếp tục, bạn đồng ý với điều khoản sử dụng của Mỹ
                  Hòa Phát
                </p>
              </motion.div>}

            {step === 'otp' && <motion.div key="otp" initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -20
          }} transition={{
            duration: 0.2
          }} data-id="element-1398">
                <button onClick={() => setStep('phone')} className="flex items-center gap-1 text-sm text-[#B0B0B0] hover:text-white mb-4 transition-colors" data-id="element-1399">
                  <ArrowLeftIcon className="w-4 h-4" data-id="element-1400" />
                  Quay lại
                </button>
                <Input label="Mã OTP (6 số)" type="text" placeholder="000000" value={otp} onChange={e => {
              const val = e.target.value.replace(/\D/g, '').slice(0, 6);
              setOtp(val);
              setOtpError('');
            }} error={otpError} leftIcon={<ShieldCheckIcon className="w-4 h-4" data-id="element-1402" />} onKeyDown={e => {
              if (e.key === 'Enter') handleOtpSubmit();
            }} autoFocus data-id="element-1401" />
                <div className="flex items-center justify-between mt-2" data-id="element-1403">
                  <span className="text-xs text-[#666666]" data-id="element-1404">
                    Demo: nhập bất kỳ 6 số
                  </span>
                  <button className="text-xs text-[#C8A84E] hover:underline" data-id="element-1405">
                    Gửi lại OTP
                  </button>
                </div>
                <Button fullWidth className="mt-4" onClick={handleOtpSubmit} isLoading={isLoading} data-id="element-1406">
                  Xác Nhận
                </Button>
              </motion.div>}

            {step === 'profile' && <motion.div key="profile" initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -20
          }} transition={{
            duration: 0.2
          }} className="space-y-4" data-id="element-1407">
                <Input label="Họ và tên" placeholder="Nguyễn Văn A" value={name} onChange={e => setName(e.target.value)} leftIcon={<UserIcon className="w-4 h-4" data-id="element-1409" />} autoFocus data-id="element-1408" />
                <Input label="Ngày sinh" type="date" value={dob} onChange={e => setDob(e.target.value)} leftIcon={<CalendarIcon className="w-4 h-4" data-id="element-1411" />} data-id="element-1410" />
                <div data-id="element-1412">
                  <label className="block text-sm font-medium text-[#B0B0B0] mb-1.5" data-id="element-1413">
                    Giới tính
                  </label>
                  <div className="flex gap-3" data-id="element-1414">
                    {[{
                  value: 'male',
                  label: 'Nam'
                }, {
                  value: 'female',
                  label: 'Nữ'
                }, {
                  value: 'other',
                  label: 'Khác'
                }].map(opt => <button key={opt.value} onClick={() => setGender(opt.value)} className={`flex-1 py-2 text-sm font-medium rounded-lg border transition-colors ${gender === opt.value ? 'border-[#C8A84E] bg-[#C8A84E]/10 text-[#C8A84E]' : 'border-[#2A2A2A] text-[#B0B0B0] hover:border-[#333333]'}`} data-id="element-1415">
                        {opt.label}
                      </button>)}
                  </div>
                </div>
                <div className="flex gap-3 pt-2" data-id="element-1416">
                  <Button variant="ghost" fullWidth onClick={handleSkipProfile} data-id="element-1417">
                    Bỏ Qua
                  </Button>
                  <Button fullWidth onClick={handleProfileSubmit} data-id="element-1418">
                    Hoàn Tất
                  </Button>
                </div>
              </motion.div>}
          </AnimatePresence>
        </div>

        {/* Step indicator */}
        <div className="flex items-center justify-center gap-2 mt-6" data-id="element-1419">
          {['phone', 'otp', 'profile'].map((s, i) => <div key={s} className={`h-1.5 rounded-full transition-all duration-300 ${s === step ? 'w-8 bg-[#C8A84E]' : i < ['phone', 'otp', 'profile'].indexOf(step) ? 'w-4 bg-[#C8A84E]/50' : 'w-4 bg-[#2A2A2A]'}`} data-id="element-1420" />)}
        </div>
      </div>
    </div>;
}